import { put } from 'redux-saga/effects';
import EventReportsActions from '../redux/EventReportsRedux';
import i18n from '../i18n';

export function* getReportModels(api, { pageParams }) {
  try {
    const getReportModelsResponse = yield api.getReportModels(pageParams);
    console.log('getReportModelsResponse:', getReportModelsResponse);
    if (getReportModelsResponse.ok) {
      yield put(
        EventReportsActions.getReportModelsRequestSuccess(
          getReportModelsResponse.data.content,
          getReportModelsResponse.data.totalElements
        )
      );
    } else {
      api.checkAuth(getReportModelsResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof getReportModelsResponse.problem !== 'undefined'
          ? getReportModelsResponse.problem
          : typeof getReportModelsResponse.data.error !== 'undefined'
          ? getReportModelsResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(EventReportsActions.getReportModelsRequestFailure(error));
    }
  } catch (error) {
    console.log('error in ReportModels saga', error);
    yield put(EventReportsActions.getReportModelsRequestFailure(error));
  }
}

export function* createReportModel(api, { reportModelInfos, pageParams }) {
  try {
    const createReportModelResponse = yield api.createReportModel(reportModelInfos);
    console.log('createReportModelResponse:', createReportModelResponse);
    const getReportModelsResponse = yield api.getReportModels(pageParams);
    const successMessage = i18n.t('successMessage.createReportModelSuccess');
    console.log('getReportModelsResponse:', getReportModelsResponse);
    if (createReportModelResponse.ok && getReportModelsResponse.ok) {
      yield put(
        EventReportsActions.createReportModelRequestSuccess(
          createReportModelResponse.data.reportModelId,
          getReportModelsResponse.data.content,
          getReportModelsResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(createReportModelResponse);
      api.checkAuth(getReportModelsResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof createReportModelResponse.problem !== 'undefined'
          ? createReportModelResponse.problem
          : typeof createReportModelResponse.data.error !== 'undefined'
          ? createReportModelResponse.data.error
          : null;
      if (errorBody) {
        let translatedError = i18n.t(`error.${errorBody}`);
        if (errorBody === 'CLIENT_ERROR') {
          translatedError = i18n.t('unexpectedError');
        }
        error += `: ${translatedError}`;
      }
      yield put(EventReportsActions.createReportModelRequestFailure(error));
    }
  } catch (error) {
    console.log('error in ReportModels saga', error);
    yield put(EventReportsActions.createReportModelRequestFailure(error));
  }
}

export function* editReportModel(api, { reportModelInfos, pageParams }) {
  console.log('reportModelInfos:', reportModelInfos);
  try {
    const editReportModelResponse = yield api.editReportModel(reportModelInfos);
    console.log('editReportModelResponse:', editReportModelResponse);
    const getReportModelsResponse = yield api.getReportModels(pageParams);
    const successMessage = i18n.t('successMessage.editReportModelSuccess');
    console.log('getReportModelsResponse:', getReportModelsResponse);
    if (editReportModelResponse.ok && getReportModelsResponse.ok) {
      yield put(
        EventReportsActions.editReportModelRequestSuccess(
          getReportModelsResponse.data.content,
          getReportModelsResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(editReportModelResponse);
      api.checkAuth(getReportModelsResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof editReportModelResponse.problem !== 'undefined'
          ? editReportModelResponse.problem
          : typeof editReportModelResponse.data.error !== 'undefined'
          ? editReportModelResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(EventReportsActions.editReportModelRequestFailure(error));
    }
  } catch (error) {
    console.log('error in ReportModels saga', error);
    yield put(EventReportsActions.editReportModelRequestFailure(error));
  }
}

export function* deleteReportModel(api, { reportModelId, pageParams }) {
  console.log('reportModelId:', reportModelId);
  try {
    const deleteReportModelResponse = yield api.deleteReportModel(reportModelId);
    console.log('deleteReportModelResponse:', deleteReportModelResponse);
    const getReportModelsResponse = yield api.getReportModels(pageParams);
    const successMessage = i18n.t('successMessage.deleteReportModelSuccess');
    console.log('getReportModelsResponse:', getReportModelsResponse);
    if (deleteReportModelResponse.ok && getReportModelsResponse.ok) {
      yield put(
        EventReportsActions.deleteReportModelRequestSuccess(
          getReportModelsResponse.data.content,
          getReportModelsResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(deleteReportModelResponse);
      api.checkAuth(getReportModelsResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof deleteReportModelResponse.problem !== 'undefined'
          ? deleteReportModelResponse.problem
          : typeof deleteReportModelResponse.data.error !== 'undefined'
          ? deleteReportModelResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(EventReportsActions.deleteReportModelRequestFailure(error));
    }
  } catch (error) {
    console.log('error in ReportModels saga', error);
    yield put(EventReportsActions.deleteReportModelRequestFailure(error));
  }
}

export function* getEventReport(api, { customerId, filters, params }) {
  try {
    const getEventReportResponse = yield api.getEventReport(customerId, filters, params);
    console.log('getEventReportResponse:', getEventReportResponse);
    if (getEventReportResponse.ok) {
      yield put(
        EventReportsActions.getEventReportRequestSuccess(
          getEventReportResponse.data.content,
          getEventReportResponse.data.totalElements
        )
      );
    } else {
      api.checkAuth(getEventReportResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof getEventReportResponse.problem !== 'undefined'
          ? getEventReportResponse.problem
          : typeof getEventReportResponse.data.error !== 'undefined'
          ? getEventReportResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(EventReportsActions.getEventReportRequestFailure(error));
    }
  } catch (error) {
    console.log('error in ReportModels saga', error);
    yield put(EventReportsActions.getEventReportRequestFailure(error));
  }
}

export function* getEventReportForExcel(api, { customerId, filters, params }) {
  try {
    const getEventReportResponse = yield api.getEventReport(customerId, filters, params);
    console.log('getEventReportResponse for Excel:', getEventReportResponse);
    if (getEventReportResponse.ok) {
      yield put(EventReportsActions.getEventReportForExcelSuccess(getEventReportResponse.data.content));
    } else {
      api.checkAuth(getEventReportResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof getEventReportResponse.problem !== 'undefined'
          ? getEventReportResponse.problem
          : typeof getEventReportResponse.data.error !== 'undefined'
          ? getEventReportResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(EventReportsActions.getEventReportForExcelFailure(error));
    }
  } catch (error) {
    console.log('error in ReportModels saga', error);
    yield put(EventReportsActions.getEventReportForExcelFailure(error));
  }
}
